(function () {
    "use strict";
    
    angular.module('app').directive('habilDropdownBranchRequired', HabilBranchDropdownDirective);
    function HabilBranchDropdownDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzField: '@',
                fodbzFieldConst: '@',
                branches: '=',
                fodbzInfo: '@',
                fodbzInfoTitle: '@',
                fodbzSizeText: '@',
                fodbzInit: '@',
            },
            template: '<select \
                            aria-describedby="{{fodbzFieldConst}}Error"  \
                            class="form-control {{fodbzSizeText}}"  \
                            ng-required="true"  \
                            ng-model="fodbzModel"  \
                            id="{{fodbzFieldConst}}" \
                            name="{{fodbzFieldConst}}" \
                            ng-options="item.BranchNbr as item.BranchDropBoxName for item in branches"  \
                            required="required"> \
                          <option ng-if="fodbzInit" value="" class="combo-placeholder">{{fodbzInit}}</option> \
                       </select>',
        };
    }
})();